export default __webpack_public_path__ + "static/media/logo2-vinho2.d5e4c986.png";